import {useState, useRef} from 'react';

// The "data" this refers to is a ref. When you update the ref data with "updateAndRender", it triggers a state change,
// which triggers a re-render. The object this custom hook returns allows direct access to the properties defined on the
// ref. This is as a replacement for a group of related individual React useState items or a useState item consisting of
// an object. Allows data updates that are instantly visible to all data accessors, allows reliable merges to the data
// (including subsequent merges, which are unreliable with a React useState item consisting of an object), provides an
// updater method similar to how this.setState() works in class components, and allows grouping of state-like data in
// one object (similar to "this.state" in class components).
export function useRenderableData(initialData) {
    const dataRef = useRef(initialData);

    // state used solely to trigger re-renders
    const [renderTimestampState, setRenderTimestampState] = useState((new Date()).getTime());

    let triggerRender = () => {
        setRenderTimestampState((new Date()).getTime())
    }

    let updateAndRender = (dataChange) => {
        dataRef.current = {
            ...dataRef.current,
            ...dataChange
        }

        triggerRender();
    }

    return {
        ...dataRef.current,
        updateAndRender: updateAndRender
    };
}
